import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import {
  ActionButton,
  AgreementContent,
  StyledButton,
  StyledCard,
  StyledCardContent,
  StyledDivider,
} from 'src/components/clubPrivacyAgreement/common'
import FullScreenBackdropDialog from 'src/components/layout/FullScreenBackdropDialog'
import useLogout from 'src/hooks/useLogout'

type ClubPrivacyAgreementErrorProps = {
  retry: () => void
  isRetrying: boolean
}

const ClubPrivacyAgreementError = ({
  retry,
  isRetrying,
}: ClubPrivacyAgreementErrorProps) => {
  const { t } = useTranslation()
  const { logout } = useLogout()

  return (
    <FullScreenBackdropDialog>
      <StyledCard raised>
        <StyledCardContent>
          <Typography variant="h6">
            {t('ClubPrivacyAgreement.title')}
          </Typography>
          <StyledDivider />
          <AgreementContent>
            <Typography variant="body1">
              {t('ClubPrivacyAgreement.fetchErrorText')}
            </Typography>
          </AgreementContent>
          <Box
            mt={8}
            mb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <StyledButton
              variant="outlined"
              color="primary"
              onClick={logout}
              disabled={isRetrying}
            >
              {t('ClubPrivacyAgreement.signOutLabel')}
            </StyledButton>
            <ActionButton
              variant="contained"
              color="primary"
              onClick={retry}
              loading={isRetrying}
            >
              {t('ClubPrivacyAgreement.retryLabel')}
            </ActionButton>
          </Box>
        </StyledCardContent>
      </StyledCard>
    </FullScreenBackdropDialog>
  )
}

export default ClubPrivacyAgreementError
